import { EntityEnums } from "../enums";

export const elvlDict = [
  {
    value: EntityEnums.Elvl.Textual,
    label: "textual",
    info: "translates what is explicitly in the text",
  },
  {
    value: EntityEnums.Elvl.Interpretive,
    label: "interpretive",
    info: "interpretation of what is explicitly in the text",
  },
  {
    value: EntityEnums.Elvl.Inferential,
    label: "inferential",
    info: "inferred from the text",
  },
];
